import {UserType} from "@/ts/Enum";

/**
 * 用户消息对象模型
 */
export default class UserChat {
    /**
     * 用户ID
     */
    id: string;
    /**
     * 用户姓名
     */
    name: string;
    /**
     * 用户头像
     */
    imgUrl: string;
    /**
     * 消息内容，私有
     */
    private message: string;
    /**
     * 消息内容展示整体居左还是居右控制。 自己发送的在右侧，收到的别人发送的在左侧
     */
    placement: 'left' | 'right' = 'left';
    /**
     * 消息内容是否是文本
     */
    isText: boolean;

    /**
     * 用户类型，教师还是学生。
     */
    type: UserType;

    /**
     * 用户性别，用于加载默认头像
     */
    gender: boolean;

    constructor(id: string, name: string, type: UserType, imgUrl: string, gender: boolean, message: string) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.imgUrl = imgUrl;
        if (null == gender || undefined == gender) {
            this.gender = true;
        } else {
            this.gender = gender;
        }
        if (message) {
            this.setMessage(message);
        }

    }

    setIsText(): boolean {
        const b = /^http[s]{0,1}:\/\//.test(this.getMessage());
        this.isText = !b;
        return !b;
    }

    // set isText(b: boolean) {
    //
    // }

    getMessage(): string {
        return this.message;
    }

    setMessage(message: string) {
        this.message = message;
        this.setIsText();
    }

    setPlacement(placement: 'left' | 'right') {
        this.placement = placement;
    }

    getPlacement(): 'left' | 'right' {
        return this.placement;
    }
}
